import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client'
import allFeatureFlagsFragment from 'graphql/fragments/allFeatureFlagsFragment'
import publicProfileCollectionFragment from 'graphql/fragments/publicProfileCollectionFragment'
import sideMenuFragment from 'graphql/fragments/sideMenuFragment'
import { currentMarketIdVar } from 'graphql/reactive'

import { PUBLIC_PROFILE_COLLECTION_VARS } from 'hooks/usePublicProfileCollection'

const PREFETCH_PUBLIC_PROFILE_COLLECTION = gql`
  query PrefetchProfileCollection(
    $marketId: ID!
    $slug: String!
    $first: Int
    $skip: Int
    $profilesPerCollection: Int! = 7
  ) {
    market(id: $marketId) {
      id
      ...publicProfileCollectionFragment
      ...sideMenuFragment
    }
    ...allFeatureFlagsFragment
  }
  ${publicProfileCollectionFragment}
  ${sideMenuFragment}
  ${allFeatureFlagsFragment}
`

async function prefetchProfileCollectionPage(
  apolloClient: ApolloClient<NormalizedCacheObject>,
  { collectionSlug }: { collectionSlug: string | string[] },
  page: string | string[],
): Promise<boolean> {
  const marketId = currentMarketIdVar()

  if (marketId) {
    await apolloClient.query({
      query: PREFETCH_PUBLIC_PROFILE_COLLECTION,
      variables: {
        ...PUBLIC_PROFILE_COLLECTION_VARS,
        slug: collectionSlug,
        marketId,
        ...(page && {
          skip:
            (parseInt(page as string, 10) - 1) *
            PUBLIC_PROFILE_COLLECTION_VARS.first,
        }),
      },
    })
  }
  return true
}

export default prefetchProfileCollectionPage
